import { useState, useContext, useEffect, useRef } from "react"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/flatpickr.min.css"
import { CiCalendar } from "react-icons/ci"
import { TimestampContext } from "./TimeStampProvider"
import { getTimestamp } from "../../Data/constant"
import { useSelector } from "react-redux"
import { selectWebsiteData } from "../../redux/general/selectors"
import { useLocalization } from "../../providers/LocalizationProvider"

const TimeDurationFilter = ({ showCustomFilter, marginEndClass = "me-4" }) => {
    const websiteData = useSelector(selectWebsiteData)
    const buttonTypes = ["This Week", "This Month", "Last Month", "This Year", "All"]
    const activeButtonType = ["this-week", "this-month", "last-month", "this-year", "all"]
    const { voiceiiTags } = useLocalization()

    const [isOpen, setIsOpen] = useState(false)
    const userContext = useContext(TimestampContext)
    const [duration, setDuration] = useState(userContext?.timestampState?.duration)
    const [activeButton, setActiveButton] = useState(
        activeButtonType.indexOf(userContext?.timestampState?.duration),
    )
    const fp = useRef(null)
    const [datePicker, updateDatePicker] = useState({
        startDate: "",
        endDate: "",
    })

    useEffect(() => {
        setActiveButton(activeButtonType.indexOf(userContext?.timestampState?.duration))
    }, [userContext?.timestampState?.duration])

    useEffect(() => {
        if (duration !== "custom") {
            const { startDate, endDate } = getTimestamp("", "", duration)
            updateDatePicker({ startDate, endDate })
            userContext.timestampDispatch({
                type: "USER",
                payload: { duration, startDate, endDate },
            })
        }
    }, [duration])

    useEffect(() => {
        if (datePicker.endDate !== "") {
            userContext.timestampDispatch({
                type: "USER",
                payload: { duration, startDate: datePicker.startDate, endDate: datePicker.endDate },
            })
        }
    }, [datePicker])

    const clickHandler = (index) => {
        setDuration(activeButtonType[index])
        setActiveButton(index)
        fp.current?.flatpickr.clear()
    }
    const ButtonGroup = buttonTypes.map((button, index) => (
        <button
            type="button"
            style={{ border: "1px solid lightgray", borderRadius: "12px" }}
            className={`btn btn-sm e-btn-outline-secondary custom-button ${
                activeButton === index ? "active" : ""
            }`}
            onClick={() => clickHandler(index)}
            key={index}
        >
            {voiceiiTags(button)}
        </button>
    ))

    const handleDateChange = (e) => {
        try {
            const tempDatePicker = { ...datePicker }

            // e[0] captures the start date, calculated in timestamp number format
            if (e[0] !== undefined) {
                tempDatePicker.startDate = e[0].toISOString()
            }
            // e[1] captures the end date, , calculated in timestamp number format
            if (e[1] !== undefined) {
                tempDatePicker.endDate = e[1].toISOString()
                // Get the duration for which the range is selected in days.
                const timeFrame = (e[1].getTime() - e[0].getTime()) / (24 * 60 * 60 * 1000)

                //  if range is within 365 days set it as a valid date else create an alert.
                if (timeFrame > 365) {
                    alert("Range selected is greater than 12 months")
                    fp.current?.flatpickr.clear()
                }
                setDuration("custom")
                updateDatePicker(tempDatePicker)
            }
        } catch (e) {
            // eslint-disable-next-line
            // console.warn("Error: ", e)
        }
    }
    const openFlatpickr = () => {
        if (fp && fp.current) {
            if (isOpen) {
                fp.current.flatpickr.close()
                setIsOpen(false)
            } else {
                setIsOpen(true)
                fp.current.flatpickr.open()
            }
        }
    }
    const tertiaryColor = websiteData.tertiary || "#ffffff"

    return (
        <>
            <style>
                {` 
           .e-btn-outline-secondary:hover {
            background-color: ${websiteData.primary_colour} !important;
            color: ${tertiaryColor} !important;
           }
            .e-btn-outline-secondary.active {
            background-color: ${websiteData.primary_colour} !important;
            color: ${tertiaryColor} !important;
           }
          `}
            </style>

            <div className="d-flex justify-content-end flex-wrap align-items-center w-100">
                <div className="d-flex flex-wrap gap-1 me-1">{ButtonGroup}</div>
                {showCustomFilter && (
                    <div
                        className={`position-relative d-flex gap-1 ${marginEndClass} e-time-duration-filter-container`}
                    >
                        <div className="position-relative">
                            <Flatpickr
                                className="form-control e-flatpickr-input-width-240px"
                                placeholder={voiceiiTags("Select Custom Duration")}
                                onChange={(e) => handleDateChange(e)}
                                onClick={() => setActiveButton(-1)}
                                ref={fp}
                                options={{
                                    dateFormat: "j/m/Y",
                                    enableTime: false,
                                    maxDate: "today",
                                    mode: "range",
                                }}
                            />
                            <CiCalendar className="calendar-icon" onClick={openFlatpickr} />
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default TimeDurationFilter
